<!-- 采购结算申请数据操作 -->
<template>
  <div>
    <subComponents ref="showSelectData"></subComponents>
    <purchaseGoodsTemplate @selectDataAction="selectDataAction" ref="purchaseGoodsTemplate"></purchaseGoodsTemplate>
    <div>
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="tabHeight">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0&&scope.row.isShowForm!=1">
                  <el-form label-width="150px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                    <el-row v-if="dataActionBox.actionType != 2">
                      <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: formOneValue.isChange == 1, trigger: ['blur', 'change']}] : []">
                        <!-- 验收单号 -->
                        <el-input v-if="formOneValue.entityField == 'dpsmId'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField" @keyup.enter.native="openExtract(formOneValue.extractId, formOneKey, formOneValue.entityField,formOneValue.nosetField)" :disabled="formOneValue.isChange==0 || dataActionBox.actionType == 1">
                          <el-button @click="openExtract(formOneValue.extractId, formOneKey, formOneValue.entityField,formOneValue.nosetField)" slot="append" icon="el-icon-search" :disabled="formOneValue.isChange==0 || dataActionBox.actionType == 1"></el-button>
                        </el-input>
                        <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1">
                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search" :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 1"></el-button>
                        </el-input>
                        <df-date :isShowLong="false" @keyup.enter.native="nextFocus(formOneKey)" :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                        <el-input :disabled="formOneValue.isChange == 0" v-else @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row v-if="dataActionBox.actionType == 2">
                      <el-form-item :label="formOneValue.showField+':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                        <span v-if="formOneValue.fieldType == 'date'"> {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}</span>
                        <span v-else-if="formOneValue.isRift == 1">
                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                        </span>
                        <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                      </el-form-item>
                    </el-row>
                  </el-form>

                  <!-- 明细信息 -->
                  <div>
                    <el-form :inline="true" size="mini">
                      <el-form-item>
                        <div class="flex">
                          <el-radio-group v-model="tableType" disabled>
                            <el-radio-button :label="0">按单据结算</el-radio-button>
                            <el-radio-button :label="1">按明细结算</el-radio-button>
                            <el-radio-button :label="2">实销实结</el-radio-button>
                          </el-radio-group>
                        </div>
                      </el-form-item>
                      <el-table size="mini" v-show="tableType == 0" :data="sendDataInfo.psAccountInvoiceVos" :row-class-name="tableRowClassName" border style="width: 100%" :height="mxHeight">
                        <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" :min-width="formOneValue.fieldWeight" show-overflow-tooltip v-for="(formOneValue,formOneKey) in djForm" :key="formOneKey" v-if="formOneValue.isShow==1">
                          <template slot-scope="scope">
                            <span v-if="formOneValue.isRift == 1">
                              <a @click="toDetail(sendDataInfo.psAccountInvoiceVos[scope.$index][formOneValue.riftField])">
                                {{sendDataInfo.psAccountInvoiceVos[scope.$index][formOneValue.entityField]}}</a>
                            </span>
                            <span v-else>{{sendDataInfo.psAccountInvoiceVos[scope.$index][formOneValue.entityField]}}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-table size="mini" v-show="tableType == 1||tableType==2" :data="sendDataInfo.accountInvoiceDetailVos" :row-class-name="tableRowClassName" border style="width: 100%" :height="mxHeight">
                        <el-table-column :prop="formOneValue.entityField" :min-width="formOneValue.fieldWeight" show-overflow-tooltip :label="formOneValue.showField" v-for="(formOneValue,formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow==1">
                          <template slot-scope="scope">
                            <span v-if="formOneValue.isRift == 1">
                              <a @click="toDetail(sendDataInfo.accountInvoiceDetailVos[scope.$index][formOneValue.riftField])">
                                {{sendDataInfo.accountInvoiceDetailVos[scope.$index][formOneValue.entityField]}}</a>
                            </span>
                            <span v-else>{{sendDataInfo.accountInvoiceDetailVos[scope.$index][formOneValue.entityField]}}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-form>
                  </div>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <div class="foot">
          <div>
            <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印</el-button>
            <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType!=2">取消</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
          </div>
          <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
            <el-form-item :label="itemV.chineseField" v-for="(itemV,itemK) in footForm" :key="itemK">
              <el-button type="success">{{sendDataInfo[itemV.entityField]}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
      <ExtractionSchemePsSettle ref="Ps" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "../byComponents/SearchScheme.vue";
import Ps from "../byComponents/ExtractionSchemePsSettle.vue";

import purchaseGoodsTemplate from "@/components/purchaseGoodsTemplate.vue";
export default {
  name: 'psSettlementKeepAction',
  props: ['actionData'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    Ps,
    SearchScheme,
    purchaseGoodsTemplate
  },
  data() {
    //这里存放数据
    return {
      selectDataTable: false,
      dataActionBox: {
        showStatus: false,
        openMode: 'ltr' || 'rtl',
        boxTitle: '新增' || '编辑',
        actionType: 0, // 0新增，1修改
      },
      detaislDataInfo: {},
      selectedDataIndex: 0,
      selectedDataIndex1: 0,
      tableType: 0,
      sendDataInfo: {
        dpsmId: '',
        pacmDate: '',
        "psAccountInvoiceVos": [],  //按单据
        "accountInvoiceDetailVos": [],  //按明细
        "psomBusdept": 0,
        "smId": '',
        "smName": '',
        "dpsmDate": 0,
        "isWms": 0,
        "opmId": 0,
        "opmName": '',
        "pacmRemark": "",
        "desmReserves1": "",
        "desmReserves2": "",
        "desmReserves3": "",
        "desmReserves4": "",
        "desmReserves5": "",
        "desmReserves6": "",
        "salesId": "",
        "salesName": "",
        "totalCount": 0,
        "totalMoney": 0,
        "totalNumber": 0,
        "psaiId": '',
        'psomId': '',
        "depId": "",
        "depName": "",
        "coId": '',
        "coName": '',
        sbiAddress: '',
        sbiNumber: '',
        sbiName: '',
        settleMode: '',
        payMethod: '',
        abookCode: "", //账簿编号
        abookId: 0, //账簿id
        abookName: "", //账簿名称
        checkNo: "", //支票号
        remark: "" //备注
      },
      showTabs: '',
      formDataList: [],
      dictionariesData: {},
      userOneList: [],
      goodsList: [],
      storageRoomList: [],
      salesmanList: [],
      detailsBox: {
        status: false,
        type: 0,
        title: "新增" || "修改",
      },
      editDateilsIndex: "",
      exId: "",
      seId: "",
      ceshi: "",
      dialogTitle: "",
      seWidth: "",
      height: "",
      exTitle: "",
      seTitle: "",
      seWidth: "",
      exWidth: "",
      DialogVisible: false,
      DialogVisible1: false,
      DialogExtract: false,
      newFormDataList: [],
      seType: '',
      smId: '',
      parentSearchData: {
        smId: ''
      },
      parentSearchData1: {
        smId: '',
        coId: '',
        opmId: '',
        salesId: '',
        depId: ''
      },
      searchId: '',
      mxHeight: 0,
      isDisabled: false,
      tabForm: [],
      mxForm: [],
      djForm: [],
      footForm: [],
      sField: ''
    };
  },
  //监听属性 类似于data概念
  computed: {
  },
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    tabHeight(val) {
      this.mxHeight = val
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById('mainInfo')
      if (el) this.inputel = el.getElementsByTagName('input')
    },
    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == '') {
          this.inputel[index].focus()
          break
        }
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      console.log(arr)
      arr.forEach(item => {
        this.sendDataInfo[item] = val[item]
      })
      this.$nextTick(() => {
        this.nextFocus(this.seIndex)
      })
    },
    // 输入框切换焦点
    nextFocus(index) {
      if (index >= (this.inputel.length - 1)) {
        return
      }
      var aindex = index + 1
      if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
        this.nextFocus(aindex)
        return
      }
      this.inputel[aindex].focus()
    },
    showPrintPlan() { // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
      } else {
        return
      }
    },
    // 子组件穿透方法
    toDetail(orderId) {
      if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
      else this.$parent.$parent.$parent.toDetail(orderId)
    },
    changeInputModel(val) {
      console.log(val)
      if (val != "" || val != undefined) {
        this.paramValue(val)
      }
      this.DialogVisible = false
    },
    async getDataByChen(val) {
      if (val != "" || val != undefined) {
        this.tableType = val.settleMode
        if (val.applyType == '预付款登记') this.isDisabled = true
        else this.isDisabled = false
        if (val.settleMode == 0) {
          for (let key in val) {
            this.sendDataInfo[key] = val[key]
          }
          this.sendDataInfo.psAccountInvoiceVos = val.arrlistbychen
          this.sendDataInfo.totalCount = this.sendDataInfo.psAccountInvoiceVos.length
        } else {
          for (let key in val) {
            this.sendDataInfo[key] = val[key]
          }
          this.sendDataInfo.accountInvoiceDetailVos = val.arrlistbychen
          this.sendDataInfo.totalCount = this.sendDataInfo.accountInvoiceDetailVos.length
        }
        this.parentSearchData.smId = val.smId
        this.DialogExtract = false;
        this.$nextTick(() => {
          this.nextFocus(this.seIndex)
        })
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    // 提取方案Id, 索引(表格中), 标识
    openExtract(eId, index, type) {
      this.DialogExtract = true
      this.exId = eId
      this.seIndex = index
      this.seType = type
      this.ppId = 'pscamId'
    },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      if (type == 'sbiName') {
        if (this.parentSearchData.smId == '') {
          return this.$message({
            message: '请先选择供应商',
            type: 'warning'
          });
        }
      }
      this.DialogVisible = true;
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
      this.sField = sField;
      this.parentSearchData[type] = this.sendDataInfo[type];
    },
    getSeWidth(e) {
      console.log(e);
      this.seWidth = e + "%";
    },
    getWidth(e) {
      console.log(e);
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      console.log(e);
      this.seTitle = e;
    },
    getExtractName(e) {
      console.log(e);
      this.exTitle = e;
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    detailsAction(cate = 0) {
      if (cate == 0) {
        this.editDateilsIndex = ""
        return false
      }

      var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo))
      if (dataInfo.psodPacknum <= 0) {
        this.$message({
          message: '请填写采购数量',
          type: 'error'
        });
        return false
      }
      if (this.editDateilsIndex !== "") {
        this.sendDataInfo.pisOrderDetail.splice(this.editDateilsIndex, 1)
      }
      this.sendDataInfo.pisOrderDetail.push(dataInfo)
      // console.log('this.sendDataInfo.pisOrderDetail',this.sendDataInfo.pisOrderDetail)
      this.editDateilsIndex = ""
      this.detailsBox.status = false
    },
    initActionBox(sendDataInfo) {
      this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$common.delOrderInfo(this.sendDataInfo.dpsmId)
        this.$emit('drawerCancel')
        this.init()
        this.$refs.sendDataInfo.resetFields();
      }).catch(() => {
      });

    },
    init() {
      for (let key in this.sendDataInfo) {
        if (key == 'pisOrderAuxinf') {
          for (let sonOne in this.sendDataInfo[key]) {
            this.sendDataInfo[key][sonOne] = ''
          }
        } else {
          this.sendDataInfo[key] = ''
        }
      }
      this.sendDataInfo.dpsmDate = this.$moment().valueOf();

      this.sendDataInfo.accountInvoiceDetailVos = []
      this.sendDataInfo.psAccountInvoiceVos = []
      this.sendDataInfo.isWms = 0
      this.sendDataInfo.totalMoney = 0
      this.sendDataInfo.totalNumber = 0
      this.sendDataInfo.totalCount = 0
    },

    // 选择采购员
    selectUserOne(data) {
      data.forEach(item => {
        if (item.opmId == this.sendDataInfo.opmId) {
          this.sendDataInfo.psomBusdept = item.depId
        }
      })
    },
    async isShowData(name, value) {
      switch (name) {
        case 'supplier':
          var dataInfo = sessionStorage.getItem('selectSupplierData')
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo)
            this.sendDataInfo.smId = dataInfo.smId
            this.sendDataInfo.smName = dataInfo.smName

          }
          this.sendDataInfo.salesId = ''
          this.getUnitSalesmanList()
          break;
        case 'cargoOwner':
          var dataInfo = sessionStorage.getItem('selectCargoOwnerData')
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo)
            this.sendDataInfo.pisOrderAuxinf.coId = dataInfo.coId
            this.sendDataInfo.pisOrderAuxinf.coName = dataInfo.coName
          }
          break;


      }


    },
    selectDataAction(data) {
      this.detaislDataInfo = {
        // "bgmId":data.bgmId,
        "bgmId": data.bgmId,
        "bgmName": data.bgmName,
        "inRate": data.bgfIntaxrate,
        bgmManufacturer: data.bgmManufacturer,
        bgmSpecifications: data.bgmSpecifications,
        bgmPlaceorigin: data.bgmPlaceorigin,
        "money": 0,
        "psodPacknum": 0,
        "price": 0,
        "psodPsdvolume": 0,
        "psodPslowerlimit": 0,
        "psmoney": 0,
        "psodPsnvolume": 0,
        "psprice": 0,
        "psodPsupperlimit": 0,
        "pspmId": '',
        "stId": data.stId,
        "pspdId": '',
        "psodReserves1": "",
        "psodReserves2": "",
        "psodReserves3": "",
        "psodReserves4": "",
        "psodReserves5": "",
        "psodReserves6": "",
      }
      this.selectDataTable = false
    },

    openBox() {
      this.dataActionBox.actionType = this.actionData.cate
      this.formDataList = this.actionData.formData
      var oldData = this.actionData.oldData
      this.showTabs = this.actionData.formData[0].jciName
      this.init()
      this.filterMainField()
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = '新增信息'
        this.dataActionBox.openMode = 'ltr'
        for (let key in this.parentSearchData) {
          this.parentSearchData[key] = ''
        }
        this.sendDataInfo.pacmDate = this.$moment().valueOf();
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = '编辑信息'
        this.dataActionBox.openMode = 'rtl'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }
        this.smId = dataInfo.smId
        this.tableType = dataInfo.settleMode
        this.getUnitSalesmanList()
      } else {
        this.dataActionBox.boxTitle = '查看信息'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }
        this.tableType = dataInfo.settleMode
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.mxHeight = this.$common.getHeight()
          }
          this.initFocus()
        }, 100)
      })
    },
    sendDataAction(sendDataInfo) {
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.sub(sendDataInfo)
        } else {
          return this.$message({
            message: '请完善信息',
            type: 'error'
          });
        }
      })
    },
    async sub(sendDataInfo) {
      if (this.tableType == 0) {
        this.sendDataInfo.settleMode = 0
        var data1 = []
        this.sendDataInfo.psAccountInvoiceVos.forEach(item => {
          data1.push({
            dapmId: item.dapmId,
            dpsdId: item.dpsdId,
            oldBalance: item.oldBalance,
            settleMoney: item.settleMoney
          })
        })
        this.sendDataInfo.settleAccountDetailAdds = data1
      } else {
        this.sendDataInfo.settleMode = 1
        var data2 = []
        this.sendDataInfo.accountInvoiceDetailVos.forEach(item => {
          data2.push({
            dapdId: item.dapdId,
            dpsdId: item.dpsdId,
            oldBalance: item.oldBalance,
            settleMoney: item.settleMoney,
            settleCount: item.settleCount
          })
        })
        this.sendDataInfo.settleAccountDetailAdds = data2
      }
      var responseData = await this.$http.addPsSettlementKeep(this.sendDataInfo)
      if (responseData.status == 200) {

        this.init()
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.$refs.sendDataInfo.resetFields();
        this.$emit('drawerCancel')

      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    deleteDetails() {
      if (this.tableType == 0) {
        if (this.sendDataInfo.psAccountInvoiceVos.length > 0) {
          this.sendDataInfo.psAccountInvoiceVos.splice(this.selectedDataIndex, 1)
          this.selectedDataIndex = 0
          this.sendDataInfo.totalCount = this.sendDataInfo.psAccountInvoiceVos.length
        } else {
          return this.$message({
            message: '暂无可删除明细',
            type: 'warning'
          })
        }
      } else if (this.tableType == 1||this.tableType==2) {
        if (this.sendDataInfo.accountInvoiceDetailVos.length > 0) {
          this.sendDataInfo.accountInvoiceDetailVos.splice(this.selectedDataIndex1, 1)
          this.selectedDataIndex1 = 0
          this.sendDataInfo.totalCount = this.sendDataInfo.accountInvoiceDetailVos.length
        } else {
          return this.$message({
            message: '暂无可删除明细',
            type: 'warning'
          })
        }
      }
    },
    // 获取业务员
    async getUnitSalesmanList() {

      this.salesmanList = []
      let responseData = await this.$http.getUnitSalesmanList({ ids: [this.sendDataInfo.smId] })
      if (responseData.status == 200) {
        this.salesmanList = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    // 获取供货员
    async getSpecialUser() {

      let responseData = await this.$http.getSpecialUser({ opmBuyer: 1 })
      if (responseData.status == 200) {
        this.userOneList = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    // 获取字典数据
    async getPartDictionariesData() {
      let responseData = await this.$http.getPartDictionariesData({ ids: [20, 21] })
      if (responseData.status == 200) {
        this.dictionariesData = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    // 获取所有可用库房列表
    async getAllStorageRoom() {
      let responseData = await this.$http.getAllStorageRoom()
      if (responseData.status == 200) {
        this.storageRoomList = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = [];
      var mxFormList = [];
      this.formDataList.forEach((item) => {
        if (item.jciType == 1) {
          mainFormList.push(item);
        } else if (item.jciType == 2) {
          mxFormList.push(item);
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
        }
      });
      this.djForm = mxFormList[0].jurconfigform;
      this.mxForm = mxFormList[1].jurconfigform;
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key));
        this.tabForm[i].jurconfigform = [];
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1)
            this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
        }
      });
    },



  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox()
    })
    this.getSpecialUser()
    this.getUnitSalesmanList()
    this.getPartDictionariesData()
    this.getAllStorageRoom()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {  },
  beforeCreate() {
  }, //生命周期 - 创建之前
  beforeMount() {
  }, //生命周期 - 挂载之前
  beforeUpdate() {
  }, //生命周期 - 更新之前
  updated() {
    this.getMainInput()
  }, //生命周期 - 更新之后
  beforeDestroy() {
  }, //生命周期 - 销毁之前
  destroyed() {
  }, //生命周期 - 销毁完成
  activated() {
  }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}
.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}
.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}
.el-drawer {
  outline: none;
}
.flex {
  display: flex;
  align-items: center;
}
</style>